<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="title">Painting Perspective, Depth &amp; Distance</h1>
<p class="sub_heading"><span class="bold">IN WATERCOLOUR</span></p>
<p class="author"><span class="bold">Geoff Kersey</span></p>
<div class="img_container-1">
<img alt="image" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Title.vue?0b9cfdbf